import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FormTemplateProfile, PreLoading } from '@tripian/react';
import { api } from '@tripian/core';
import Model from '@tripian/model';
import { useHistory } from 'react-router';
import ICombinedState from '../../redux/model/ICombinedState';

import { USER_PROFILE, USE_TRIP_URL } from '../../constants/ROUTER_PATH_TITLE';
import { changeUser } from '../../redux/action/user';
import config from '../../config';
import useQuestionProfile from '../../hooks/useQuestionProfile';
import AppNav from '../../App/AppNav/AppNav';

const UserProfile = () => {
  const { loadingQuestionsProfile, questionsProfile } = useQuestionProfile();
  const user = useSelector((state: ICombinedState) => state.user.user);
  const dispatch = useDispatch();
  const history = useHistory();

  document.title = `${USER_PROFILE.TITLE}`;

  useEffect(() => {
    const redirectToUseTripUrl = () => {
      history.replace(USE_TRIP_URL.PATH);
    };

    if (config.HIDE_USER_PROFILE) {
      redirectToUseTripUrl();
    }
  }, [history]);

  const updateCallback = (updatedUser: Model.User) => {
    dispatch(changeUser(updatedUser));
  };

  const update = (value: Model.UserUpdateRequest) => api.userUpdate(value);

  if (!user) return null;

  return (
    <>
      <AppNav header={USER_PROFILE.HEADER} />

      {loadingQuestionsProfile ? (
        <PreLoading bgColor="rgba(238, 238, 238, 0.8)" />
      ) : (
        <div className="container mt10">
          <div className="row center">
            <FormTemplateProfile
              user={user}
              profileQuestions={questionsProfile || []}
              updateUser={update}
              updateCallback={updateCallback}
              cancel={() => {
                history.goBack();
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default UserProfile;
